module.exports = __webpack_public_path__ + "static/media/GoogleDA-1.75cdfb01.jpg";